// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.JmmnCuAuuAjTetUvSNgw{min-width:67px}`, "",{"version":3,"sources":["webpack://./src/widgets/TextToSpeech/ui/TextToSpeechModalActions/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,cAAA","sourcesContent":[".button {\n  min-width: 67px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `JmmnCuAuuAjTetUvSNgw`
};
export default ___CSS_LOADER_EXPORT___;
